import $ from 'jquery';
/* eslint-disable import/no-named-as-default, import/no-named-as-default-member */
import Calendar from './calendar';

class StayTab {
  options = {
    selectors: {
      codeType: '.js-booking-stay-code-type',
      codeHotel: '.js-booking-stay-code-hotel',
      code: '.js-booking-stay-code',
      fieldForm: '.field-form',
      hotelDropdawn: '.select-filter_proper ul li',
    },
    classes: {
      fieldFormDisabled: 'field-form--disabled',
    },
  };

  constructor() {
    if (!document.querySelector('.booking-widget') || !document.querySelector('#stay-content')) {
      return;
    }
    this.syncCodeTypeAndCodeFields();
    this.syncCodeHotelFields();
    this.syncActionPath();
    this.codeHotel = $(this.options.selectors.codeHotel).val();

    setTimeout(() => {
      Calendar.CheckinCheckOut(this.codeHotel);
    }, 1000);
  }

  syncCodeHotelFields() {
    $(this.options.selectors.codeHotel).on('change', (event) => {
      this.codeHotel = event.target.value;
      Calendar.CheckinCheckOut(this.codeHotel);
    });
  }

  syncCodeTypeAndCodeFields() {
    $(this.options.selectors.codeType).on('change', (event) => {
      const { value } = event.target;
      const $code = $(this.options.selectors.code);

      if (value.length) {
        // update stored code
        if (this.options?.codeValue) {
          $code.val(this.options.codeValue);
        }
        // eslint-disable-next-line max-len
        $code.closest(this.options.selectors.fieldForm).removeClass(this.options.classes.fieldFormDisabled);
        $code.prop('disabled', false);
      } else {
        this.options.codeValue = $code.val();
        $code.val('');
        // eslint-disable-next-line max-len
        $code.closest(this.options.selectors.fieldForm).addClass(this.options.classes.fieldFormDisabled);
        $code.prop('disabled', true);
      }
    });
  }

  syncActionPath() {
    const hotelDropdown = document.querySelectorAll(this.options.selectors.hotelDropdawn);

    StayTab.updateDatesNamesOnTheLoad();

    hotelDropdown.forEach((hotelElement) => {
      hotelElement.addEventListener('click', function () {
        const $this = $(this);
        const form = $('#stay-content form');
        const stateRQ = form.find('input[name="stateRQ"]');
        const regionRQ = form.find('input[name="regionRQ"]');

        if ($this.hasClass('optionState') || $this.hasClass('optionTown')) {
          const definedArg = $this.text().trim().toLowerCase().replaceAll(' ', '-');

          if ($this.hasClass('optionState')) {
            stateRQ.val(definedArg);
            regionRQ.val('');
          } else if ($this.hasClass('optionTown')) {
            regionRQ.val(definedArg);
            stateRQ.val('');
          }

          const actionLocation = form.data('location-action');
          form.attr('action', actionLocation);
          StayTab.renameStartEnd(actionLocation, form);
          return;
        }

        if ($this.data('path')) {
          form.attr('action', $this.data('path'));
          StayTab.renameStartEnd($this.data('path'), form);
          stateRQ.val('');
          regionRQ.val('');
        }
      });
    });
  }

  static updateDatesNamesOnTheLoad() {
    const form = $('#stay-content form');
    StayTab.renameStartEnd(form.attr('action'), form);
  }

  static renameStartEnd(actionLocation, form) {
    const from = form.find('#bookingStartDate');
    const to = form.find('#bookingEndDate');

    if (actionLocation.includes('be.synxis.com')) {
      from.attr('name', 'arrive');
      to.attr('name', 'depart');
    } else if (from.length && to.length) {
      from.attr('name', 'startDate');
      to.attr('name', 'endDate');
    }
  }
}

export default StayTab;
